export default __webpack_public_path__ + "static/media/listor8.f93ce66e.png";